import React from "react";
import ParentProducts from "./ParentProducts";

// Define the props type for NewSimilarProducts
interface NewSimilarProductsProps {
  lang: string;
}

const NewSimilarProducts: React.FC<NewSimilarProductsProps> = ({ lang }) => {
  return (
    <div>
      <ParentProducts lang={lang} />
    </div>
  );
};

export default NewSimilarProducts;
